<template>
  <PageContainer
    :class="$style.page"
  >
    <template v-slot:body>
      <AdministratorsList
        :refreshKey="refreshKey"
      />
    </template>
    <template v-slot:sidebar>
      <AdministratorSidebar
        :itemId="itemId"
        :showSidebar="showSidebar"
        :view="view"
      />
    </template>
    <template v-slot:footer>
      <LegalNotice />
    </template>
  </PageContainer>
</template>

<script>
import { PageContainer } from '@jumpcloud/ui-components';
import {
  mapActions, mapGetters, mapState,
} from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import AdministratorSidebar from 'client/settings/AdministratorSettings/AdministratorSidebar';
import AdministratorsList from 'client/settings/AdministratorSettings/AdministratorList';
import LegalNotice from 'client/settings/components/LegalNotice.vue';
import RouteGuardMixin from 'client/AdminPortal/router/guards/RouteGuardMixin';

const administratorModel = 'AdministratorModel';

export default {
  name: 'AdministratorSettingsPage',

  components: {
    AdministratorsList,
    AdministratorSidebar,
    PageContainer,
    LegalNotice,
  },

  mixins: [RouteGuardMixin],

  data() {
    return {
      renderList: true,
    };
  },

  computed: {
    ...mapGetters(administratorModel, [
      'hasItemChanged',
    ]),

    ...mapState(administratorModel, [
      'refreshKey',
    ]),

    itemId() {
      return this.$route.params.itemId;
    },

    showSidebar() {
      return this.view != null;
    },

    view() {
      return this.$route.meta.view;
    },
  },

  mounted() {
    if (this.$route.query.success === 'oauthLinkSuccess') {
      const successQuery = { ...this.$route.query };
      delete successQuery.success;
      this.$router.replace({ query: successQuery });
      this.triggerSuccessNotification({
        title: 'Saved',
        message: 'OAuth provider linked successfully.',
      });
    }

    if (
      this.$route.query.error
      && this.$route.query.error.toLowerCase().startsWith('oauth')
    ) {
      const errorQuery = { ...this.$route.query };
      delete errorQuery.error;
      this.$router.replace({ query: errorQuery });
      this.triggerErrorNotification({
        title: 'Error',
        message: 'Error linking oauth provider.',
      });
    }
  },

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
      'triggerSuccessNotification',
    ]),

    hasModelChanged() {
      // Required for RouteGuardMixin
      return this.hasItemChanged;
    },
  },
};
</script>

<style module scoped>
.page {
  --sidebar-width: 25rem;

  background-color: var(--jcWhite50);
}
</style>
